import React, { useEffect, useState } from 'react';
import Map from './map';

const MapWrapper = (props) => {
  const [shouldRenderMap, setShouldRenderMap] = useState(true);

  useEffect(() => {
    const observer = new MutationObserver((mutationsList) => {
      for (const mutation of mutationsList) {
        if (mutation.type === 'childList') {
          const removedNodes = Array.from(mutation.removedNodes);
          const removedElement = removedNodes.find(
            (node) => node.id === 'topRedBar'
          );

          if (removedElement) {
            setShouldRenderMap(false);

            setTimeout(() => {
              setShouldRenderMap(true);
            }, 100);
          }
        }
      }
    });

    observer.observe(document.body, { childList: true, subtree: true });

    return () => {
      observer.disconnect();
    };
  }, []);

  return shouldRenderMap && <Map {...props} />;
};

export default MapWrapper;



